// @ts-strict-ignore
import { PropertyVO } from './property.vo';

export class ConnectionAreaSearchRequirementsVO {
  /**
   * Connection requirements for one connection area to fulfill. Single
   * Properties are logically connected with "AND" operator.
   * Each property may have more than one value. In this case these single values are
   * connected logically with "OR" operator
   */
  public connectionRequirements: PropertyVO[];

  public articleId: number;

  public toString(): string {
    return this.connectionRequirements ? this.connectionRequirements.join(',') : '';
  }
}
